/**
 * Who referred someone, in words and as a link.
 *
 * Every referral surface used to decide this inline with `referrerType === 'HR' ? ... : ...`,
 * which was right while there were two kinds of referrer. Programme v3 added a third, the HR
 * Ambassador, and each of those two-way checks then called an ambassador a "Job seeker" and linked
 * them to /jobseekers/{id}, a record that does not exist. One helper, so the next kind is one edit.
 */

/** The stored values of `referral.referrerType`. */
export type ReferrerType = 'HR' | 'JOBSEEKER' | 'AMBASSADOR';

export const REFERRER_LABELS: Record<ReferrerType, string> = {
  HR: 'HR',
  JOBSEEKER: 'Job seeker',
  AMBASSADOR: 'HR Ambassador',
};

/** "HR", "Job seeker" or "HR Ambassador". An unknown or missing type reads as a job seeker, as before. */
export const referrerLabel = (type: string | null | undefined): string => {
  const key = (type ?? '').toUpperCase() as ReferrerType;
  return REFERRER_LABELS[key] ?? REFERRER_LABELS.JOBSEEKER;
};

/**
 * Where a referrer's own record lives: HRs under User RBAC, ambassadors under HR Ambassadors, job
 * seekers under Job seekers.
 */
export const referrerPath = (r: { referrerType: string | null | undefined; referrerId: string }): string => {
  const id = encodeURIComponent(r.referrerId);
  switch ((r.referrerType ?? '').toUpperCase()) {
    case 'HR':
      return `/user-rbac/${id}`;
    case 'AMBASSADOR':
      return `/ambassadors/${id}`;
    default:
      return `/jobseekers/${id}`;
  }
};
